module.exports = __webpack_public_path__ + "img/50ne.2b1be9e7.svg";